import { LISTING_STATUS } from '../../../store/products/constants/listingStatus';
import { getListingChannelId } from '../../../store/products/helpers/channelIdHelpers';

const MASTER_CHANNEL_ID = 'master';

const resolveMasterProductId = (item) => {
  if (!item?.type) return null;

  switch (item.type) {
    case 'master':
      return item._id;
    case 'masterVariant':
      return item.baseProductId || null;
    case 'listing':
      return item.masterProductId || item.baseProductId || null;
    case 'listingVariant': {
      const listingProduct = item.baseProduct || item.listingProduct;
      return listingProduct?.masterProductId
        || listingProduct?.baseProductId
        || item.masterProductId
        || null;
    }
    default:
      return null;
  }
};

const resolveMasterVariantId = (item) => {
  if (!item?.type) return null;

  switch (item.type) {
    case 'masterVariant':
      return item._id;
    case 'listingVariant':
      return item.masterVariantId || null;
    default:
      return null;
  }
};

const resolveActiveTab = (item) => {
  const listingStatus = (item?.listingStatus || '').toUpperCase();
  if (listingStatus === LISTING_STATUS.DRAFT) return LISTING_STATUS.DRAFT;
  if (listingStatus === LISTING_STATUS.PUBLISHED) return LISTING_STATUS.PUBLISHED;
  return listingStatus || null;
};

export const buildProductGridItemPath = (navigation) => {
  if (!navigation?.masterProductId) return null;

  if (navigation.masterVariantId) {
    return `/product/${navigation.masterProductId}/${navigation.masterVariantId}`;
  }

  return `/product/${navigation.masterProductId}`;
};

export function getTreeSelectionItemFromNavigation(navigation) {
  if (!navigation?.masterProductId) return null;

  if (navigation.masterVariantId) {
    return {
      type: 'masterVariant',
      _id: navigation.masterVariantId,
      baseProductId: navigation.masterProductId,
    };
  }

  return {
    type: 'master',
    _id: navigation.masterProductId,
  };
}

export default function resolveProductGridItemNavigation(item, activeVersion) {
  const masterProductId = resolveMasterProductId(item);
  if (!masterProductId) return null;

  const isListing = item.type === 'listing' || item.type === 'listingVariant';
  const channelId = isListing ? getListingChannelId(item) : MASTER_CHANNEL_ID;

  if (isListing && !channelId) return null;

  const masterVariantId = resolveMasterVariantId(item);

  return {
    masterProductId,
    channelId,
    ...(masterVariantId && { masterVariantId }),
    ...(isListing && {
      activeTab: activeVersion === 'published'
        ? LISTING_STATUS.PUBLISHED
        : activeVersion === 'draft'
          ? LISTING_STATUS.DRAFT
          : resolveActiveTab(item),
    }),
  };
}

export function resolveProductGridItemParentNavigation(item, activeVersion) {
  if (!item?.type) return null;

  if (item.type === 'masterVariant') {
    if (!item.baseProductId) return null;

    return resolveProductGridItemNavigation({
      type: 'master',
      _id: item.baseProductId,
    });
  }

  if (item.type === 'listingVariant') {
    const parentProduct = item.baseProduct || item.listingProduct;

    return resolveProductGridItemNavigation({
      type: 'listing',
      _id: item.baseProductId,
      masterProductId: parentProduct?.masterProductId,
      baseProductId: parentProduct?.masterProductId || parentProduct?.baseProductId,
      salesChannelId: parentProduct?.salesChannelId || item.salesChannelId,
      salesChannel: parentProduct?.salesChannel || item.salesChannel,
      listingStatus: parentProduct?.listingStatus,
    }, activeVersion);
  }

  return null;
}
